import { render, staticRenderFns } from "./pulse.vue?vue&type=template&id=3f456008&scoped=true&"
import script from "./pulse.vue?vue&type=script&lang=js&"
export * from "./pulse.vue?vue&type=script&lang=js&"
import style0 from "./pulse.vue?vue&type=style&index=0&id=3f456008&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f456008",
  null
  
)

export default component.exports